import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Deep-link support for "create" quick actions: when the page is opened with
 * `?new=1`, call `open` once and strip the param so refresh/back don't reopen it.
 */
export function useOpenOnNewParam(open: () => void): void {
  const [params, setParams] = useSearchParams();
  const wantsNew = params.get('new') === '1';
  useEffect(() => {
    if (!wantsNew) return;
    open();
    const next = new URLSearchParams(params);
    next.delete('new');
    setParams(next, { replace: true });
  }, [wantsNew]); // eslint-disable-line react-hooks/exhaustive-deps
}
